import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { createTsdMapData, deleteTsdMapData, listTsdMaps } from '../Api/TsdMap/TsdMapApi';
import { addError, clearError } from './Error';

export interface TsdMap {
  id?: string;
  tsd_id: string;
  tsd_name: string;
  tsd_sfid?: string;
  tsd_rpm: string | null;
}

const tallyTsdMapsSubject = new BehaviorSubject<TsdMap[]>([] as TsdMap[]);
const tallyTsdMapsLoadingSubject = new BehaviorSubject<boolean>(false);

export const getTallyTsdMapsSubject = (): BehaviorSubject<TsdMap[]> => tallyTsdMapsSubject;
export const getTallyTsdMapsLoadingSubject = (): BehaviorSubject<boolean> => tallyTsdMapsLoadingSubject;

export const getTsdMapBySfTsdId = (id: string): TsdMap | null => {
  const tsdMap = getTallyTsdMapsSubject()
    .getValue()
    .find((tm) => tm.tsd_id === id);
  return tsdMap || null;
};

export const getTsdMapBySfTsdName = (name: string): TsdMap | null => {
  const tsdMap = getTallyTsdMapsSubject()
    .getValue()
    .find((tm) => tm.tsd_name === name);
  return tsdMap || null;
};

export const getTsdMapByRpmSource = (source: string | null): TsdMap | null => {
  const tsdMap = getTallyTsdMapsSubject()
    .getValue()
    .find((tm) => tm.tsd_rpm === source);
  return tsdMap || null;
};

export const fetchTsdMaps = async () => {
  tallyTsdMapsLoadingSubject.next(true);

  const { data, error } = await listTsdMaps();

  if (data?.tsdMaps) {
    clearError('tsd-map');
    tallyTsdMapsSubject.next(data.tsdMaps);
  }
  if (error) addError('tsd-map', error.message);

  tallyTsdMapsLoadingSubject.next(false);
};

export const createTsdMap = async (tsdMap: Partial<TsdMap>) => {
  const tsdMapData: TsdMap = { ...({} as TsdMap), ...tsdMap };

  const { data, error } = await createTsdMapData(tsdMapData);

  if (data) {
    clearError('tsd-map');
    fetchTsdMaps();
  }
  if (error) addError('tsd-map', error.message);

  return { data, error };
};

export const deleteTsdMap = async (id: string) => {
  const { data, error } = await deleteTsdMapData(id);

  if (data) {
    clearError('tsd-map');
    fetchTsdMaps();
  }
  if (error) addError('tsd-map', error.message);
};
